import { clearAdminSession, getAdminToken } from "./adminAuthApi";

const API_BASE_URL = (
  process.env.REACT_APP_ADMIN_API_BASE_URL ||
  "http://secondbite-manage.localhost/admin-api/v1"
).replace(/\/+$/, "");

const filtersToParams = (filters = {}) => {
  const params = new URLSearchParams();
  Object.entries(filters).forEach(([key, value]) => {
    if (value !== "" && value !== null && value !== undefined) params.set(key, value);
  });
  return params;
};

const request = async (path, options = {}) => {
  let response;
  try {
    response = await fetch(`${API_BASE_URL}${path}`, {
      ...options,
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${getAdminToken()}`,
        ...(options.headers || {}),
      },
    });
  } catch {
    throw new Error("Unable to connect to the SecondBite backend.");
  }
  const payload = await response.json().catch(() => null);
  if (response.status === 401) {
    clearAdminSession();
    window.location.replace("/login");
    throw new Error("Your session has expired.");
  }
  if (!response.ok || !payload?.success) {
    throw new Error(payload?.message || "Request failed.");
  }
  return payload;
};

export const getAdminOrderMeta = async () =>
  (await request("/orders/meta")).data;

export const listAdminOrders = async (filters) =>
  (await request(`/orders?${filtersToParams({ ...filters, per_page: 100 })}`)).data;

export const getAdminOrder = async (id) =>
  (await request(`/orders/${id}`)).data;

export const refundAdminOrder = async (id) =>
  (await request(`/orders/${id}/refund`, { method: "POST" })).data;

export const exportAdminOrders = async (filters) => {
  const response = await fetch(`${API_BASE_URL}/orders/export?${filtersToParams(filters)}`, {
    headers: {
      Accept: "text/csv",
      Authorization: `Bearer ${getAdminToken()}`,
    },
  });
  if (response.status === 401) {
    clearAdminSession();
    window.location.replace("/login");
    throw new Error("Your session has expired.");
  }
  if (!response.ok) {
    const payload = await response.json().catch(() => null);
    throw new Error(payload?.message || "Unable to export orders.");
  }
  const blob = await response.blob();
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = `secondbite-orders-${new Date().toISOString().slice(0, 10)}.csv`;
  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(url);
};
